interface MessagingIconProps {
  className?: string;
}

/**
 * Speech-bubble glyph for the Messaging nav item.
 *
 * Separate from `MessageIcon`, which is an app-icon treatment (green gradient backplate)
 * used as a channel badge in message lists. Its fills are hardcoded, so in a nav slot it
 * could not follow the active colour the way every sibling icon does. This matches the
 * nav convention instead: 20x20 viewBox, glyph only, `currentColor`.
 */
export const MessagingIcon = ({ className }: MessagingIconProps) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 2.5c-4.28 0-7.75 2.85-7.75 6.37 0 1.98 1.1 3.75 2.83 4.92-.2 1.03-.7 1.98-1.44 2.75a.5.5 0 0 0 .42.85 7.7 7.7 0 0 0 3.83-1.5c.68.15 1.4.23 2.11.23 4.28 0 7.75-2.85 7.75-6.38S14.28 2.5 10 2.5Z"
      fill="currentColor"
    />
  </svg>
);
